import { render, staticRenderFns } from "./Kontakte.vue?vue&type=template&id=65234cff&scoped=true"
import script from "./Kontakte.vue?vue&type=script&lang=js"
export * from "./Kontakte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65234cff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65234cff')) {
      api.createRecord('65234cff', component.options)
    } else {
      api.reload('65234cff', component.options)
    }
    module.hot.accept("./Kontakte.vue?vue&type=template&id=65234cff&scoped=true", function () {
      api.rerender('65234cff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Kontakte.vue"
export default component.exports